import InputBox from '../../component/InputBox';
import { modalType, convertModalType } from '../../util/ModalUtil';
import { useRef, useState } from 'react';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import { actionSmsSend } from '../../module/body/sms/SmsSendModule';
import { useDispatch } from 'react-redux';
import PopupRef from '../../component/PopupRef';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import TelNoInputBox from '../../component/TelNoInputBox';

const SmsSendTestModal = ({ state, modalRef, popupRef }) => {
    const dispatch = useDispatch();
    const { sendTypeCd, callback, title, msg } = state;

    const [phone, setPhone] = useState('');

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleConfirm = () => {
        if (phone == undefined || phone == null || phone == '') {
            popupRef.current.openAlert('테스트 수신 번호를 입력하세요.');
        } else {
            dispatch(
                actionSmsSend({
                    data: {
                        sendTypeCd,
                        callback,
                        title,
                        msg,
                        phoneList: [phone],
                    },
                    callback: (result) => {
                        let msg = '';
                        if (result.success > 0) {
                            msg = 'SMS 발송 테스트에 성공 했습니다.';
                        } else {
                            msg = 'SMS 발송 테스트에 실패 했습니다.';
                        }
                        popupRef.current.openAlert(msg);
                    },
                }),
            );
        }
    };

    return (
        <>
            <ModalHeader title={'SMS 테스트 발송'} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner'>
                    <InfoTxt infoTxt='SMS 발송 테스트합니다.' />
                    <div className='form-box-row'>
                        <TelNoInputBox title='테스트 수신번호' value={phone} setTelNo={setPhone} />
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={() => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={() => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SmsSendTestModal;
